import { SuccessSwal, SwalPost } from "../../app";
import { ajaxPost, ajaxErrorAlert } from "../utils";

$(function () {
  const body = $("body");

  if (body.hasClass("ip-network-list")) {
    const table = $("#ipNetworksTable");
    const form = $("#ipNetworksFilterForm");

    table.DataTable({
      ajax: {
        type: "POST",
        data: function (d) {
          for (let v of Object.values(form.serializeArray())) {
            d[v.name] = v.value;
          }
        },
      },
    });

    form.on("submit", (e) => {
      e.preventDefault();
      table.DataTable().ajax.reload();
    });

    $(document).on("click", ".rowActionMenuBtn", (e) => {
      const btn = $(e.currentTarget);
      const rowId = btn.closest("tr").attr("id");
      const menu = btn.parent().find(".rowActionMenu");

      ajaxPost(rowId + "/action-buttons/", {}, btn).then((response) => {
        menu.html(String(response["html"]));
      });
    });

    $(document).on("click", ".deleteIpNetwork", (e) => {
      e.preventDefault();
      const url = $(e.currentTarget).attr("href");
      SwalPost(
        url,
        {},
        {
          text: "IP-ni silmək istədiyinizdən əminsinizmi?",
          icon: "warning",
        },
      ).then(() => {
        SuccessSwal.fire({ timer: 1000 }).then(() => {
          table.DataTable().ajax.reload();
        });
      });
    });
  }

  if (
    body.hasClass("ip-network-create") ||
    body.hasClass("ip-network-update")
  ) {
    const form = $("#userUpdateCreateIpNetwork");

    form.on("submit", (e) => {
      e.preventDefault();

      ajaxPost("", form.serializeArray(), form)
        .then((response) => {
          SuccessSwal.fire({ timer: 1000 }).then(() => {
            window.location.href = String(response["redirect_url"]);
          });
        })
        .catch((errors) => {
          ajaxErrorAlert(errors, form);
        });
    });
  }
});
